// extracted by mini-css-extract-plugin
export var label = "_5r-1";
export var reminder = "_5r-0";